<script>

import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex';
import moduleUtils from '../ModuleUtils';
import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';


export default {
  props: [
    'title',
    'formIdentifier',
    'customTemplate',
    'parentId'
  ],
  components: {
    SgsRenderNotificationSuccess,
    SgsRenderNotificationError
  },
  data: function() {
    return {
      currentView: '',
      template: '',
      script: null,
      params: {},
      instance: null,
      notificationError: null,
      notificationSuccess: null
    }
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'showLoader',
      'hideLoader'
    ]),
    callBusinessRule: function(instance, businessRuleId) {

      this.showLoader();

      moduleUtils.callBusinessRule(this.formIdentifier, instance, businessRuleId)
        .then(response => {
          this.hideLoader();

          _.forOwn(response.body.instance, (value, key) => {
            this.$set(instance, key, value);
          });

          this.notificationError = response.body.notificationError;
          this.notificationSuccess = response.body.notificationSuccess;
        })
    },
    actionLinkSelected: function(formId, dataRow) {
      this.$emit('actionLinkSelected', formId, dataRow);
    }
  },
  mounted: function() {
    if (this.customTemplate) {

      this.params.urlAttachment = moduleUtils.resolveFormDesc(this.formIdentifier) + "/attachment";
      this.params.parentId = this.parentId;
      this.params.moment = require('moment');
      this.params.formIdentifier = this.formIdentifier;
      this.params.userLanguage = this.$i18n.locale;

      let vueJson = eval('(' + this.customTemplate.script + ')');
      vueJson.template = this.customTemplate.template;

      let customDynamicComponentName = "customDynamicComponent_" + this.formIdentifier.formId;

      Vue.component(customDynamicComponentName, vueJson);
      this.currentView = customDynamicComponentName;
    }
  }
}
</script>

<template>
  <div>

    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <div class="page-header">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">

        <component
          :is="currentView"
          :params="params"
          @callBusinessRule="callBusinessRule"
          @actionLinkSelected="actionLinkSelected"
        >
        </component>

      </div>
    </div>

  </div>
</template>

<style scoped>
  @import '~fullcalendar/dist/fullcalendar.css';
</style>



// WEBPACK FOOTER //
// ModuleCustom.vue?45d5cb7e